export default __webpack_public_path__ + "static/media/glovo.4f740087.svg";